import React from "react";
import "./FinkraftBenefits.scss";
import EmailFollowup from "static/images/LandingOne.svg";
import Control from "../../../assets/images/Control.png";
import GSTAutomation from "../../../assets/images/GSTAutomation.png";

interface BenefitItemProps {
  title: string;
  description: string;
  imageSrc?: string;
}

const BenefitItem: React.FC<BenefitItemProps> = ({
  title,
  description,
  imageSrc,
}) => {
  return (
    <div className="benefit-item">
      <div className="benefit-image">
        {imageSrc ? (
          <img src={imageSrc} alt={title} />
        ) : (
          <div className="placeholder-image"></div>
        )}
      </div>
      <div className="benefit-text">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

const FinkraftBenefits: React.FC = () => {
  const benefits = [
    {
      title: "No More Email Follow-Ups Instant Access to Invoices",
      description:
        "Say goodbye to endless email threads and delays. Simply search by employee name or trip ID, recover pending invoices, and download them with ease, all in one place. Built for speed, transparency, and control.",
      // imageSrc: "/assets/businessman-chart.jpg"
      imageSrc: EmailFollowup,
    },
    // {
    //   title: "AI Checks Every Field Against GSTN In Real Time",
    //   description: "Our advanced AI engine performs real-time validation of each field against the GSTN database..."
    // },
    // {
    //   title: "Invoices Stamped With IRN & QR Code For Audit Trail",
    //   description: "Each invoice generated through our system is stamped with a unique Invoice Reference Number (IRN)..."
    // },
    {
      title: "Your Dedicated Space to Collaborate & Control",
      description:
        "You get your own secure and personalized workspace to manage transactions, track invoices, and streamline workflows. Add team members with role-based access, assign responsibilities, and collaborate seamlessly, all within a centralized environment designed to grow with your business.",
      imageSrc: Control,
    },
    {
      title: "Built By Finkraft, India's Leading GST-Automation Firm",
      description:
        "Finkraft is a trusted leader in GST automation, renowned for delivering high-quality, compliant solutions. With years of expertise in the field, our platform provides a seamless, robust, and reliable system designed to simplify your tax processes and ensure you stay ahead of the curve with evolving GST regulations.",
      imageSrc: GSTAutomation,
    },
  ];

  return (
    <section className="finkraft-benefits-section">
      <div className="benefits-header">
        <span className="benefits-label">BENEFITS</span>
        <h2>The Finkraft Difference</h2>
      </div>
      <div className="benefits-container">
        {benefits.map((benefit, index) => (
          <BenefitItem
            key={index}
            title={benefit.title}
            description={benefit.description}
            imageSrc={benefit.imageSrc}
          />
        ))}
      </div>
    </section>
  );
};

export default FinkraftBenefits;
